/* tslint:disable:no-invalid-template-strings */

import { find, template } from 'lodash';
import { createSelector } from 'reselect';

const apiEndpoint = 'https://s3.amazonaws.com/orpheus-assets/country-list';
const apiPostalCodeFile = 'postal-codes.json';
const apiCountriesFile = 'countries.json';
const apiStatesFile = template('countries/${countryFileId}.json');

export const getCountryList = ({ countryList: { countries } }: IStoreState) => countries;
export const getStateList = ({ countryList: { states } }: IStoreState) => states;
export const getPostalCodes = ({ countryList: { postalCodes } }: IStoreState) => postalCodes;

function apiFetch<T>(url: string): T {
  return (fetch as any)(`${apiEndpoint}/${url}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'get',
  }).then((response) => response.json() as T);
}

export const areCountriesAlreadyFetched = () => createSelector(
  getCountryList,
  (countries) => !!countries.length,
);

export const areCountryStatesAlreadyFetched = (countryId: string) => createSelector(
  getStateList,
  (states) => states.hasOwnProperty(countryId) as boolean,
);

export const fetchPostalCodes = () => apiFetch<IPostalCodeValidationList>(apiPostalCodeFile);
export const fetchCountries = () => apiFetch<ICountry[]>(apiCountriesFile);
export function fetchStatesForCountry({ code, filename }: ICountry) {
  return new Promise<ICountryStateActionPayload>(async (resolve, reject) => {
    try {
      const states = await apiFetch<ICountryState[]>(apiStatesFile({ countryFileId: filename }));
      resolve({ states, countryId: code });
    } catch (e) {
      reject(e);
    }
  });
}

export function fetchCountriesAndPostalCodes(): Promise<ICountryActionPayload> {
  return new Promise<ICountryActionPayload>(async (resolve, reject) => {
    try {
      const countries: ICountry[] = await fetchCountries();
      const postalCodes: IPostalCodeValidationList = await fetchPostalCodes();
      resolve({ countries, postalCodes });
    } catch (e) {
      reject(e);
    }
  });
}

export const getCountryFromCode = (countryCode: string) => createSelector(
  getCountryList,
  (countries) => countries.length ?
    find(countries, { code: countryCode })
    : undefined,
);

export const getCountryLabelFromCode = (countryCode: string) => createSelector(
  getCountryFromCode(countryCode),
  (country) => country ? country.name : undefined,
);

export const getStateLabelFromCode = (stateCode: string) => createSelector(
  getStateList,
  (states) => {
    const countryCode = stateCode.split('-')[0];
    return states.hasOwnProperty(countryCode) ?
      find(states[countryCode], { code: stateCode })!.name
      : undefined;
  },
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/countries.ts